import { useQuery } from '@tanstack/react-query';
import { GpsAndBorderCrossingConfigurationModel } from './types';
import { mockedGpsData } from './mock';
import { QUERY_KEY_SETTINGS_GPS, SETTINGS_QUERY_NO_CACHE } from '@/lib/api/constants'
import { COMPANY_API_SETTINGS_MOCKED } from '@/env';
import { getGpsSettings } from './getGpsSettings';

export function useQueryGpsSettings(companyId: string) {
  return useQuery<GpsAndBorderCrossingConfigurationModel>({
    queryKey: [QUERY_KEY_SETTINGS_GPS, companyId],
    queryFn: async () => {
      if (COMPANY_API_SETTINGS_MOCKED) {
        return mockedGpsData
      }
      const { data } = await getGpsSettings({ companyId })
      return data;
    },
    enabled: !!companyId,
    ...SETTINGS_QUERY_NO_CACHE,
  });
}
